export default __webpack_public_path__ + "static/media/template-2.e6b27dee.png";